import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ApiVisa} from '../../shared/api-visa.model';

interface ShopifyAuthDtoModel {
  access_token?: string;
  store_name?: string;
  api_version?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShopifyAuthorizationService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopify/private-app';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopify/private-app';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopify/private-app';
    this.httpClient = http;
  }

  postShopifyAuthorization(branchGuid: string, dto: ShopifyAuthDtoModel, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?branch_guid=' + branchGuid;
    return this.httpClient.post(url, dto, this.getHttpHeader(apiVisa));
  }

  deleteShopifyAuthorization(branch_guid: string, resource_guid: string, app_name: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `?branch_guid=${branch_guid}&app_generic_resource_guid=${resource_guid}&private_app_name=${app_name}`;
    return this.httpClient.delete(url, this.getHttpHeader(apiVisa));
  }

}
